import React from 'react';
import CharactersCollideScene from 'game/scenes/test/CharactersCollideScene';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function CharactersCollideScenePage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [CharactersCollideScene],
            physics: {
              arcade: {
                debug: true,
              }
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
